import PropTypes from 'prop-types';
import ICONS from '../../../../../../enums/icons';
import { Button } from '../../../../../ui/button';
import { ModalFooter } from '../../../../../ui/modal';

const FooterNews = ({ onValidate, isSubmitDisabled }) => {
    return (
        <ModalFooter>
            <Button
                type='submit'
                entity={'button.submit'}
                variant='primary'
                size='auto'
                icon={ICONS.VALIDATE}
                onClick={onValidate}
                disabled={isSubmitDisabled} />
        </ModalFooter>
    );
};

FooterNews.propTypes = {
    onValidate: PropTypes.func.isRequired,
    isSubmitDisabled: PropTypes.bool
};

export default FooterNews;